import { CommonUtils } from "../../../utils/common.util";
/**
 * Created by Vasilenko on 12-Nov-16.
 */
export var Tile = (function () {
    function Tile(position, value) {
        var _this = this;
        this.value = value;
        this.id = "";
        this.merged = false;
        this.isNew = false;
        this.bgStatus = "";
        this.getValue = function () { return _this.value; };
        this.id = CommonUtils.genUuid();
        this.setPosition(position);
        this.merged = false;
    }
    Tile.prototype.prepareState = function () {
        this.origPosition = this.position.clone();
        this.merged = false;
        this.isNew = false;
    };
    Tile.prototype.setMergedBy = function (arr) {
        var self = this;
        arr.forEach(function (tile) {
            tile.merged = true;
            tile.setPosition(self.getPosition());
        });
    };
    Tile.prototype.setValue = function (newVal) {
        this.value = newVal;
        this.recalcBgClass();
    };
    Tile.prototype.setPosition = function (newPosition) {
        this.position = newPosition.clone();
    };
    Tile.prototype.getPosition = function () {
        return this.position.clone();
    };
    Tile.prototype.setIsNew = function (isnew) {
        this.isNew = isnew;
    };
    Tile.prototype.recalcBgClass = function () {
        this.bgStatus = this.value < 64 ? "" :
            this.value < 256 ? "bg-info" :
                this.value < 512 ? "bg-warning" :
                    this.value < 1024 ? "bg-success" :
                        this.value < 2048 ? "bg-primary" : "bg-error";
    };
    return Tile;
}());
//# sourceMappingURL=tile.model.js.map